// import React, { useState, useEffect, useRef } from 'react';
// import { CRow, CCol } from '@coreui/react';
// import { useHistory } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { getOffer } from 'src/actions/AllOffersActions';
// import { imgUrl } from 'src/actions/types';

// const useDraggableScroll = (ref) => {
//   useEffect(() => {
//     const element = ref.current;
//     if (!element) return;
//     let isDown = false, startX, scrollLeft;
//     element.style.cursor = 'grab';
//     const onDown = (e) => { isDown = true; element.classList.add('active-dragging'); element.style.cursor = 'grabbing'; startX = e.pageX - element.offsetLeft; scrollLeft = element.scrollLeft; };
//     const onLeave = () => { element.style.cursor = 'grab'; };
//     const onUp = () => { isDown = false; element.classList.remove('active-dragging'); element.style.cursor = 'grab'; };
//     const onMove = (e) => { if (!isDown) return; e.preventDefault(); element.scrollLeft = scrollLeft - (e.pageX - element.offsetLeft - startX) * 2; };
//     element.addEventListener('mousedown', onDown);
//     element.addEventListener('mouseleave', onLeave);
//     element.addEventListener('mouseup', onUp);
//     element.addEventListener('mousemove', onMove);
//     return () => { element.removeEventListener('mousedown', onDown); element.removeEventListener('mouseleave', onLeave); element.removeEventListener('mouseup', onUp); element.removeEventListener('mousemove', onMove); };
//   }, [ref]);
// };

// const OfferSection = () => {
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const offerScrollRef = useRef(null);
//   const [offers, setOffers] = useState([]);

//   useDraggableScroll(offerScrollRef);

//   const getOfferImage = (offerImage) => {
//     if (offerImage && offerImage.trim() !== '') {
//       if (offerImage.startsWith('http')) return offerImage;
//       const baseUrl = imgUrl.endsWith('/') ? imgUrl.slice(0, -1) : imgUrl;
//       const imagePath = offerImage.startsWith('/') ? offerImage.slice(1) : offerImage;
//       return `${baseUrl}/${imagePath}`;
//     }
//     return '/assets/img/offers/default_offer_image.jpg';
//   };

//   const truncateDescription = (description, maxLength = 50) => {
//     if (!description) return 'No description available.';
//     const plainText = description.replace(/<[^>]*>/g, '');
//     return plainText.length <= maxLength ? plainText : plainText.substring(0, maxLength) + '...';
//   };

//   const formatTimeRemaining = (endDate) => {
//     if (!endDate) return 'Expired';
//     const end = new Date(endDate);
//     end.setHours(23, 59, 59, 999);
//     const diffTime = end - new Date();
//     if (diffTime <= 0) return 'Expired';
//     const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
//     return days > 0 ? `${days} days remaining` : 'Ending soon';
//   };

//   const handleSeeMoreClick = (id) => history.push(`/offer-details#offer-${id}`);

//   useEffect(() => {
//     const fetchOffers = async () => {
//       try {
//         const response = await dispatch(getOffer());
//         if (response?.data) {
//           const today = new Date();
//           today.setHours(0, 0, 0, 0);
//           const valid = response.data.filter(offer => {
//             const end = new Date(offer.endDate);
//             return offer.status?.toLowerCase() === 'publish' && end >= today;
//           });
//           setOffers(valid);
//         }
//       } catch (err) { console.error(err); }
//     };
//     fetchOffers();
//   }, [dispatch]);

//   return (
//     <>
//       <style>{`
//         .offer-section-wrapper { margin-bottom: 2rem; }

//         .offer-scroll-row {
//           display: flex;
//           flex-direction: row;
//           overflow-x: auto;
//           gap: 20px;
//           padding: 25px 15px;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//           -webkit-overflow-scrolling: touch;
//           cursor: grab;
//           user-select: none;
//         }
//         .offer-scroll-row::-webkit-scrollbar { display: none !important; }
//         .offer-scroll-row.active-dragging { cursor: grabbing !important; }

//         .offer-card {
//           height: 150px;
//           width: 350px;
//           flex: 0 0 350px;
//           background: #fff;
//           border-radius: 14px;
//           overflow: hidden;
//           display: flex;
//           border: 1px solid #eee;
//           box-shadow: 0 4px 15px rgba(0,0,0,0.06);
//           transition: box-shadow 0.3s ease, transform 0.3s ease;
//           cursor: pointer;
//           position: relative;
//         }
//         .offer-card:hover { box-shadow: 0 8px 24px rgba(0,0,0,0.15); transform: translateY(-6px); }

//         .offer-card-image {
//           flex: 0 0 70%;
//           background: #ffffff;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 10px;
//           pointer-events: none;
//         }
//         .offer-card-image img {
//           max-width: 100%;
//           max-height: 100%;
//           object-fit: contain;
//           filter: drop-shadow(0 3px 6px rgba(0,0,0,0.08));
//         }

//         .offer-card-stub {
//           flex: 0 0 30%;
//           padding: 15px 10px;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//           background: #fff;
//           border-left: 2px dashed #e5e5e5;
//           position: relative;
//         }
//         .offer-card-stub::before, .offer-card-stub::after {
//           content: '';
//           position: absolute;
//           width: 20px;
//           height: 20px;
//           background: #f8f9fa;
//           border-radius: 50%;
//           left: -11px;
//           border: 1px solid #eee;
//         }
//         .offer-card-stub::before { top: -10px; }
//         .offer-card-stub::after { bottom: -10px; }

//         .offer-time-remaining { font-size: 9px; color: #f08a24; font-weight: 800; text-transform: uppercase; }
//         .offer-title { font-size: 13px; font-weight: 700; color: #333; margin: 6px 0; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.2; }
//         .offer-description { font-size: 10.5px; color: #777; line-height: 1.3; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
//         .offer-see-more { font-size: 11px; font-weight: 700; color: #007bff; text-decoration: underline; cursor: pointer; }
//         .offer-see-more:hover { color: #0056b3; }

//         @media (max-width: 768px) {
//           .offer-card { width: 300px; flex: 0 0 300px; height: 130px; }
//         }
//         @media (max-width: 576px) {
//           .offer-scroll-row { padding: 15px 5px; gap: 10px; }
//           .offer-card { width: 280px; flex: 0 0 280px; height: 120px; }
//         }
//       `}</style>

//       <section className="container offer-section-wrapper">
//         <CRow className="align-items-center">
//           <CCol xl={3} lg={4} md={12}>
//             <div className="section-header">
//               <h2 style={{ color: '#333', fontWeight: '800' }}>Special Offers</h2>
//               <p className="text-muted">
//                 Unlock exclusive discounts and health packages—available for a limited time.
//               </p>
//               <button className="view-button" onClick={() => history.push('/offer-details')}>
//                 Explore All Offers
//               </button>
//             </div>
//           </CCol>

//           <CCol xl={9} lg={8} md={12}>
//             <div ref={offerScrollRef} className="offer-scroll-row">
//               {offers.length > 0 ? (
//                 offers.map((offer) => (
//                   <div key={offer.id} className="offer-card" onClick={() => handleSeeMoreClick(offer.id)}>
//                     <div className="offer-card-image">
//                       <img
//                         src={getOfferImage(offer.image)}
//                         alt={offer.title}
//                         draggable="false"
//                         onError={(e) => e.target.src = '/assets/img/offers/default_offer_image.jpg'}
//                       />
//                     </div>
//                     <div className="offer-card-stub">
//                       <div>
//                         <div className="offer-time-remaining">{formatTimeRemaining(offer.endDate)}</div>
//                         <h5 className="offer-title">{offer.title}</h5>
//                         <p className="offer-description">{truncateDescription(offer.description, 50)}</p>
//                       </div>
//                       <div className="offer-see-more">See more →</div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="p-4 text-muted">No active offers at the moment.</div>
//               )}
//             </div>
//           </CCol>
//         </CRow>
//       </section>
//     </>
//   );
// };

// export default OfferSection;




























import React, { useState, useEffect, useRef } from 'react';
import { CRow, CCol } from '@coreui/react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getOffer } from 'src/actions/AllOffersActions';
import { imgUrl } from 'src/actions/types';

const useDraggableScroll = (ref) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    let isDown = false, startX, scrollLeft;
    element.style.cursor = 'grab';
    const onDown = (e) => { isDown = true; element.classList.add('active-dragging'); element.style.cursor = 'grabbing'; element.style.userSelect = 'none'; startX = e.pageX - element.offsetLeft; scrollLeft = element.scrollLeft; e.preventDefault(); };
    const onLeave = () => { element.style.cursor = 'grab'; };
    const onUp = () => { isDown = false; element.classList.remove('active-dragging'); element.style.cursor = 'grab'; element.style.userSelect = ''; };
    const onMove = (e) => { if (!isDown) return; e.preventDefault(); element.scrollLeft = scrollLeft - (e.pageX - element.offsetLeft - startX) * 2; };
    element.addEventListener('mousedown', onDown);
    element.addEventListener('mouseleave', onLeave);
    element.addEventListener('mouseup', onUp);
    element.addEventListener('mousemove', onMove);
    return () => { element.removeEventListener('mousedown', onDown); element.removeEventListener('mouseleave', onLeave); element.removeEventListener('mouseup', onUp); element.removeEventListener('mousemove', onMove); };
  }, [ref]);
};

const OfferSection = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const offerScrollRef = useRef(null);
  const [offers, setOffers] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());

  useDraggableScroll(offerScrollRef);

  // ✅ Countdown timer - same as AppoinmentApp
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const getOfferImage = (offerImage) => {
    if (offerImage && offerImage.trim() !== '') {
      try {
        if (offerImage.startsWith('http')) return offerImage;
        const baseUrl = imgUrl.endsWith('/') ? imgUrl.slice(0, -1) : imgUrl;
        const imagePath = offerImage.startsWith('/') ? offerImage.slice(1) : offerImage;
        return `${baseUrl}/${imagePath}`;
      } catch (error) {
        return '/assets/img/offers/default_offer_image.jpg';
      }
    }
    return '/assets/img/offers/default_offer_image.jpg';
  };

  const truncateDescription = (description, maxLength = 80) => {
    if (!description) return 'No description available.';
    const plainText = description.replace(/<[^>]*>/g, '');
    return plainText.length <= maxLength ? plainText : plainText.substring(0, maxLength) + '...';
  };

  // ✅ Same formatTimeRemaining as AppoinmentApp (with hrs/min/sec)
  const formatTimeRemaining = (endDate) => {
    if (!endDate) return 'Expired';
    try {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      const diffTime = end - new Date();
      if (diffTime <= 0) return 'Expired';
      const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffTime % (1000 * 60)) / 1000);
      if (days > 1) return `${days} days remaining`;
      if (days === 1) return `1 day remaining`;
      if (hours > 0 || minutes > 0 || seconds > 0) return `${hours} hrs ${minutes} min ${seconds} sec remaining`;
      return 'Expired';
    } catch (error) {
      return 'Invalid date';
    }
  };

  const handleSeeMoreClick = (offerId) => {
    if (!offerId) { history.push('/offer-details'); window.scrollTo(0, 0); return; }
    try { history.push(`/offer-details#offer-${offerId}`); window.scrollTo(0, 0); }
    catch (error) { history.push('/offer-details'); window.scrollTo(0, 0); }
  };

  // ✅ Same offer filtering as AppoinmentApp (with startDate check)
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await dispatch(getOffer());
        if (response && response.data) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const validOffers = response.data.filter((offer) => {
            if (!offer.status || offer.status.toLowerCase() !== 'publish') return false;
            if (!offer.startDate || !offer.endDate) return false;
            try {
              const startDate = new Date(offer.startDate);
              startDate.setHours(0, 0, 0, 0);
              const endDate = new Date(offer.endDate);
              endDate.setHours(23, 59, 59, 999);
              return today >= startDate && today <= endDate;
            } catch (dateError) { return false; }
          });

          const sortedOffers = validOffers.sort((a, b) => {
            const dateA = new Date(a.createdAt || a.startDate);
            const dateB = new Date(b.createdAt || b.startDate);
            return dateB - dateA;
          });

          setOffers(sortedOffers);
        } else {
          setOffers([]);
        }
      } catch (error) {
        console.error('Failed to fetch offers', error);
        setOffers([]);
      }
    };
    fetchOffers();
  }, [dispatch]);

  return (
    <>
      <style>{`
        .offer-section-wrapper { margin-bottom: 2rem; }
        .offer-scroll-row {
          display: flex; flex-direction: row; overflow-x: auto;
          gap: 20px; padding: 25px 15px;
          scrollbar-width: none; -ms-overflow-style: none;
          -webkit-overflow-scrolling: touch; cursor: grab; user-select: none;
        }
        .offer-scroll-row::-webkit-scrollbar { display: none !important; }
        .offer-scroll-row.active-dragging { cursor: grabbing !important; }

        .split-voucher-card {
          height: 150px; width: 350px; flex: 0 0 350px;
          background: #fff; border-radius: 14px; overflow: hidden;
          display: flex; border: 1px solid #eee;
          box-shadow: 0 4px 15px rgba(0,0,0,0.06);
          transition: box-shadow 0.3s ease, transform 0.3s ease;
          cursor: pointer; position: relative;
        }
        .split-voucher-card:hover { box-shadow: 0 8px 24px rgba(0,0,0,0.15); transform: translateY(-6px); }

        .offer-img-section {
          flex: 0 0 70%; background: #ffffff;
          display: flex; align-items: center; justify-content: center;
          padding: 10px; pointer-events: none;
        }
        .offer-img-section img {
          max-width: 100%; max-height: 100%;
          object-fit: contain;
          filter: drop-shadow(0 3px 6px rgba(0,0,0,0.08));
        }

        .offer-stub-section {
          flex: 0 0 30%; padding: 15px 10px;
          display: flex; flex-direction: column; justify-content: space-between;
          background: #fff; border-left: 2px dashed #e5e5e5; position: relative;
        }
        .offer-stub-hole {
          position: absolute; width: 20px; height: 20px;
          background: #f8f9fa; border-radius: 50%; left: -11px; border: 1px solid #eee;
        }
        .offer-stub-hole.top { top: -10px; }
        .offer-stub-hole.bottom { bottom: -10px; }

        .offer-time-badge { font-size: 9px; color: #f08a24; font-weight: 800; text-transform: uppercase; }
        .offer-card-title { font-size: 13px; font-weight: 700; color: #333; margin: 6px 0; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.2; }
        .offer-card-desc { font-size: 10.5px; color: #777; line-height: 1.3; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
        .offer-see-more { font-size: 11px; font-weight: 700; color: #007bff; text-decoration: underline; cursor: pointer; }
        .offer-see-more:hover { color: #0056b3; }

        @media (max-width: 576px) {
          .offer-scroll-row { padding: 15px 5px; gap: 10px; }
          .split-voucher-card { width: 300px; flex: 0 0 300px; height: 130px; }
        }
      `}</style>

      <section className="container offer-section-wrapper">
        <CRow className="align-items-center">
          <CCol xl={3} lg={4} md={12}>
            <div className="section-header">
              <h2 >Special Offers</h2>
              <p className="text-muted">
                Unlock exclusive discounts and health packages—available for a limited time.
              </p>
              <button className="view-button" onClick={() => history.push('/offer-details')}>
                Explore All Offers
              </button>
            </div>
          </CCol>

          <CCol xl={9} lg={8} md={12} className="px-0">
            <div
              ref={offerScrollRef}
              className="offer-scroll-row d-flex flex-nowrap"
            >
              {offers && offers.length > 0 ? (
                offers
                  .sort((a, b) => new Date(b.createdAt || b.startDate) - new Date(a.createdAt || a.startDate))
                  .map((offer) => (
                    <div
                      key={offer.id}
                      className="split-voucher-card"
                      onClick={() => handleSeeMoreClick(offer.id)}
                    >
                      {/* LEFT IMAGE */}
                      <div className="offer-img-section">
                        <img
                          src={getOfferImage(offer.image)}
                          alt={offer.title}
                          draggable="false"
                          onError={(e) => e.target.src = '/assets/img/offers/default_offer_image.jpg'}
                        />
                      </div>

                      {/* RIGHT STUB */}
                      <div className="offer-stub-section">
                        <div className="offer-stub-hole top" />
                        <div className="offer-stub-hole bottom" />

                        <div>
                          <div className="offer-time-badge">
                            {formatTimeRemaining(offer.endDate)}
                          </div>
                          <h5 className="offer-card-title">
                            {offer.title || 'Special Offer'}
                          </h5>
                          <p className="offer-card-desc">
                            {truncateDescription(offer.description, 40)}
                          </p>
                        </div>

                        <div
                          className="offer-see-more"
                          onClick={(e) => { e.stopPropagation(); handleSeeMoreClick(offer.id); }}
                        >
                          See more →
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <div className="text-center w-100 py-4">
                  <p className="text-muted">No offers available at the moment.</p>
                </div>
              )}
            </div>
          </CCol>
        </CRow>
      </section>
    </>
  );
};

export default OfferSection;